import React, { useEffect, useRef, useState } from "react";
import api from "../lib/api";

// Kalıp kodu yazınca Bisküvi Stok'tan ürün açıklamasını getirir
export default function StockAutocomplete({ value, onChange, onPick, testid }) {
  const [q, setQ] = useState(value || "");
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => { setQ(value || ""); }, [value]);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const search = async (text) => {
    if (!text) { setOpts([]); return; }
    try {
      const r = await api.get(`/entity/stock?q=${encodeURIComponent(text)}`);
      const seen = new Set();
      const list = r.data.filter((x) => x.kalip_kodu && !seen.has(x.kalip_kodu) && seen.add(x.kalip_kodu)).slice(0, 12);
      setOpts(list);
      setOpen(true);
    } catch { setOpts([]); }
  };

  const pick = (row) => {
    setQ(row.kalip_kodu);
    onChange(row.kalip_kodu);
    onPick && onPick(row);
    setOpen(false);
  };

  return (
    <div className="relative" ref={boxRef}>
      <input
        data-testid={testid}
        value={q}
        onChange={(e) => { setQ(e.target.value); onChange(e.target.value); search(e.target.value); }}
        onFocus={() => q && search(q)}
        placeholder="Kalıp kodu yazın..."
        className="w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm mono focus:outline-none focus:ring-2 focus:ring-amber-600"
        autoComplete="off"
      />
      {open && opts.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-y-auto bg-white border border-zinc-300 shadow-lg rounded-sm">
          {opts.map((p) => (
            <button type="button" key={p.kalip_kodu} onClick={() => pick(p)}
              className="w-full text-left px-3 py-2 hover:bg-amber-50 border-b border-zinc-100 last:border-0">
              <div className="mono text-sm text-zinc-900">{p.kalip_kodu}</div>
              <div className="text-xs text-zinc-500 truncate">{p.urun_aciklamasi || "—"}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
